import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';

import { FlexibleContent, HeroSlider } from '@/templates';
import { getBaseLayout } from '@/layouts/BaseLayout';

import { InstantSearch, ListOfProducts } from '@/components/algolia';
import { getFiltrableFields, getInitialProps } from '@/lib/graphql/api';
import {
  FlexibleContentBlocks,
  pagePropsPartial,
  sliderHero,
} from '@/lib/graphql/partials';
import { PageQuery } from '@/lib/graphql/querys';
import { pagePropsServerTransformer } from '@/lib/graphql/transformers';

import type { NextPageWithLayout } from './_app';

const SearchResult: NextPageWithLayout<any> = ({
  pageProps: { filtrableFields },
  page: { flexibleContent, hero },
}) => {
  const router = useRouter();
  const search = router.query.search as string;
  const session: any = useSession();

  return (
    <>
      <HeroSlider hero={hero} />
      <InstantSearch>
        <ListOfProducts
          filtrableFields={filtrableFields}
          title={search}
          query={search}
          type="search"
          categoryAtribute="hierarchicalCategories.lvl0"
          userId={session?.data?.user?.UID}
        />
      </InstantSearch>
      <FlexibleContent type="Page" flexible={flexibleContent.flexible} />
    </>
  );
};

export const getStaticProps = async () => {
  const {
    data: { filtrableFields },
  } = await getFiltrableFields();
  const page = `
    page(id: $slug, idType: URI) {
      flexibleContent: ${FlexibleContentBlocks('Page')}
      hero: ${sliderHero('Page')}
    }
  `;
  const Query = PageQuery(pagePropsPartial, page);
  const staticProps = await pagePropsServerTransformer({
    staticProps: await getInitialProps(Query, { slug: 'buscador' }),
    type: 'Page',
    path: 'buscador',
  });

  if (staticProps.notFound) {
    return {
      notFound: true,
    };
  }

  staticProps.props.pageProps.filtrableFields = filtrableFields || [];

  return staticProps;
};

SearchResult.getLayout = getBaseLayout;

export default SearchResult;
